var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "rb-3d-banner__container" },
    [
      _c("rb-banner", {
        staticClass: "rb-3d-product",
        attrs: {
          "image-desktop": _vm.image,
          "is-copy-external": true,
          "is-lazy-load-enabled": false,
          "text-align": "center",
          "is-v-cta-directive-enabled": true,
          "is-dummy-banner": _vm.isDummyBanner,
          "image-alt": _vm.imageAlt,
        },
        scopedSlots: _vm._u([
          {
            key: "title_block",
            fn: function () {
              return [_c("h2", [_vm._v(_vm._s(_vm.product.modelName))])]
            },
            proxy: true,
          },
          {
            key: "excerpt_block",
            fn: function () {
              return [
                _c("rb-3d-product-prices", { attrs: { prices: _vm.prices } }),
              ]
            },
            proxy: true,
          },
          {
            key: "cta_block",
            fn: function () {
              return [
                _c(
                  "a",
                  {
                    staticClass: "rb-btn rb-btn--black",
                    attrs: {
                      href: _vm.product.pdpUrl,
                      "data-description": _vm.dataDescription,
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.translation("common.shop_now")) +
                        "\n      "
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }